import React, { useState } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { HiOutlineTrash } from "react-icons/hi";

const ModalComponent = ({
  isOpen,
  onRequestClose,
  extractedData,
  handleSendAllMessages,
  handleScheduleAllMessages,
  setExtractedData,
  getRowPreviewText,
}) => {
  const [scheduleTime, setScheduleTime] = useState("");

  const handleScheduleMessages = async () => {
    if (!scheduleTime) {
      toast.error("Please select a scheduled time.");
      return;
    }
    await handleScheduleAllMessages(scheduleTime);
    onRequestClose();
  };

  // Filter out rows with empty data (Mobile No or Name)
  const filteredData = extractedData.filter((item) => item[0] && item[1]);

  // Handle deletion of a row with confirmation
  const handleDelete = (index) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      const updatedData = [...extractedData];
      updatedData.splice(index, 1);
      setExtractedData(updatedData);
      toast.success("Record deleted successfully!");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Extracted Data"
      ariaHideApp={false}
      className="relative mx-auto my-8 w-11/12 max-w-5xl rounded-2xl border border-indigo-200 bg-white/95 p-3 shadow-2xl outline-none backdrop-blur"
      overlayClassName="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/55"
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* <h2 className="text-2xl font-bold text-center text-[#25D366] mb-6">
          Extracted Data
        </h2> */}

        {/* Scrollable Table */}
        <div className="max-h-96 overflow-y-auto rounded-xl border border-indigo-200 shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="sticky top-0 z-10 bg-gradient-to-r from-indigo-100/90 via-violet-100/90 to-indigo-100/90">
              <tr>
                <th className="px-2 py-1.5 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-700">Mobile No</th>
                <th className="px-2 py-1.5 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-700">Name</th>
                <th className="px-2 py-1.5 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-700">DOB</th>
                <th className="px-2 py-1.5 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-700">Preview</th>
                <th className="px-2 py-1.5 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-indigo-100 bg-white/80">
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <motion.tr
                    key={index}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    className="divide-x divide-indigo-100 border-b border-indigo-100 transition-colors hover:bg-indigo-50/60"
                  >
                    <td className="px-2 py-1 text-xs text-slate-700">
                      {item[0]}
                    </td>
                    <td className="px-2 py-1 text-xs text-slate-700">
                      {item[1]}
                    </td>
                    <td className="px-2 py-1 text-xs text-slate-700">
                      {item[2] || "N/A"}
                    </td>
                    <td className="max-w-64 px-2 py-1 text-xs text-slate-700">
                      <p className="line-clamp-2 whitespace-pre-wrap">
                        {getRowPreviewText ? getRowPreviewText(item) : "No message"}
                      </p>
                    </td>
                    <td className="px-2 py-1 text-center">
                      <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => handleDelete(index)}
                        className="font-medium text-rose-500 transition-colors hover:text-rose-700"
                      >
                        <HiOutlineTrash />
                      </motion.button>
                    </td>
                  </motion.tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-4 py-6 text-center text-slate-500"
                  >
                    No valid data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Schedule Time Input */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-6"
        >
          <label className="block text-x font-medium text-gray-700 mb-2">
            Schedule Time
          </label>
          <input
            type="datetime-local"
            value={scheduleTime}
            onChange={(e) => setScheduleTime(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#25D366] transition-all"
          />
        </motion.div> */}

        {/* Action Buttons */}
        <div className="flex flex-wrap justify-end gap-4 mt-2">
          {/* <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleSendAllMessages}
            className="bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white py-2 px-6 rounded-md font-semibold shadow-md hover:shadow-lg transition-all"
          >
            Send All Messages
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleScheduleMessages}
            className="bg-gradient-to-r from-[#1EBE5A] to-[#128C7E] text-white py-2 px-6 rounded-md font-semibold shadow-md hover:shadow-lg transition-all"
          >
            Schedule All Messages
          </motion.button> */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onRequestClose}
            className="rounded-xl border border-indigo-200 bg-white px-3 py-1 text-xs font-semibold text-slate-700 shadow-sm transition-all hover:bg-indigo-50"
          >
            Close
          </motion.button>
        </div>
      </motion.div>
    </Modal>
  );
};

export default ModalComponent;
